import { createSlice } from '@reduxjs/toolkit'
import asyncGetList from '../thunks/paycheck/asyncGetList';
import asyncPaycheckDownload from '../thunks/paycheck/asyncPaycheckDownload';

const initialState = {
    year: 2022,
    pdfList: [],
    error: null,
    message: null
}

const paycheckSlise = createSlice({
    name: 'paycheck',
    initialState,
    reducers: {
        setYear(state, action) {
            state.year = action.payload;
        }
    },
    extraReducers: builder => {
        // Async Get List
        builder.addCase(asyncGetList.pending, (state, action) => {
            state.pdfList = []
            state.message = "Загрузка..."
        })
        builder.addCase(asyncGetList.fulfilled, (state, action) => {
            const {data} = action.payload;

            if (!data?.length) {
                state.message = "Ничего не найдено";
                return;
            }

            state.pdfList = data;
            state.message = null;
        })
        builder.addCase(asyncGetList.rejected, (state, action) => {
            state.message = null;
        })
        // Async Donwload File
        builder.addCase(asyncPaycheckDownload.fulfilled, (state, action) => {
            
        })
    }
});

export const { setYear } = paycheckSlise.actions;
export default paycheckSlise.reducer;